<template>
  <tr>
    <!-- value -->
    <!-- <td align="left" v-html="termValue"  @click="view(term.id)" style="color:blue;cursor:pointer!important"> -->
    <!-- </td> -->
    <!-- created_at -->
    <td>
      {{ term.created_at | formatDate }}
    </td>
    <td>
      <div>
        <a class="dropdown-toggle" data-toggle="dropdown" href="#">
          <span class="fas fa-ellipsis-v color-default"></span>
        </a>
        <ul class="dropdown-menu">
          <template>
            <router-link class="dropdown-item" :to="'term&conditions/' + this.term.id">View</router-link>
            <!-- <a class="dropdown-item" @click="download(term)" >Download</a> -->
          </template>
        </ul>
      </div>
    </td>
  </tr>
</template>

<script>
  import moment from "moment";
  import $ from "jquery";
 
  Vue.filter("formatDate", function (value) {
    if (value != "0000-00-00 00:00:00" && value != null) {
      return moment(String(value)).format("MMM DD, Y LT");
    }
  });
  export default {
    props: ["term"],

    computed: {
      // termValue: function () {
      //  if (this.term.value && this.term.value.length > 200) {
      //   var data = this.term.value.substr(0,100);
      //     return data;
      //   }else if(this.term.value && this.term.value.length < 200){
      //     return this.term.value;
      //   }
      //   else {
      //   return 'No content';
      //   }
      // }
    },
    methods: {
      view(id) {
        this.$router.push("/term&conditions/" + id);
      },
    },
  };
</script>